module.exports = __webpack_public_path__ + "static/media/manager-mapping-logo.5d4a9c0e.svg";